module.exports = __webpack_public_path__ + "static/media/9.6806fcf1.mp3";